var render = function render(){var _vm=this,_c=_vm._self._c;return _c(_vm.forms[_vm.step],{tag:"component",attrs:{"csrf":_vm.csrf,"phone":_vm.phone,"uid":_vm.uid,"until":_vm.until},on:{"go-step":function($event){return _vm.goStep($event)}}})
}
var staticRenderFns = []

export { render, staticRenderFns }